var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAudioOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_122_7950)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.22 1.25624C10.05 1.17624 9.85 1.19624 9.7 1.30624L5.83 4.20624H3C1.62 4.20624 0.5 5.32624 0.5 6.70624V9.70624C0.5 11.0862 1.62 12.2062 3 12.2062H5.83L9.7 15.1062C9.79 15.1762 9.89 15.2062 10 15.2062C10.08 15.2062 10.15 15.1862 10.22 15.1562C10.39 15.0662 10.5 14.8962 10.5 14.7062V1.70624C10.5 1.51624 10.39 1.34624 10.22 1.25624ZM11.6464 5.85397C11.8417 5.6587 12.1583 5.6587 12.3536 5.85397L14 7.50041L15.6464 5.85397C15.8417 5.6587 16.1583 5.6587 16.3536 5.85397C16.5488 6.04923 16.5488 6.36581 16.3536 6.56107L14.7071 8.20752L16.3536 9.85397C16.5488 10.0492 16.5488 10.3658 16.3536 10.5611C16.1583 10.7563 15.8417 10.7563 15.6464 10.5611L14 8.91463L12.3536 10.5611C12.1583 10.7563 11.8417 10.7563 11.6464 10.5611C11.4512 10.3658 11.4512 10.0492 11.6464 9.85397L13.2929 8.20752L11.6464 6.56107C11.4512 6.36581 11.4512 6.04923 11.6464 5.85397Z",
    fill: "#F5F5F5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_122_7950"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5 0.20752)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAudioOff);
export default __webpack_public_path__ + "static/media/icon-audio-off.6a53e20a1708a58b741237a796b5de27.svg";
export { ForwardRef as ReactComponent };